import {Component, OnInit} from '@angular/core';
import {BannerBase} from '../banner-base';
import {DialogService} from '../../../../core/services/dialog.service';
import {Ga4EventsConfigService} from '../../../../core/services/ga4-events-config.service';
import {Ga4OffersElementKey} from '../../../../core/consts/ga4-offers-element-key.enum';

@Component({
  selector: 'app-accidents-happen-banner',
  templateUrl: './accidents-happen-banner.component.html',
  styleUrls: ['./accidents-happen-banner.component.scss']
})
export class AccidentsHappenBannerComponent extends BannerBase implements OnInit {

  get leftImageSrc(): string {
    return './assets/images/banners/accidents-happen.png';
  }

  constructor(public dialogService: DialogService,
              private ga4EventsService: Ga4EventsConfigService) {
    super(dialogService);
  }

  ngOnInit() {
  }

  openPopup() {
    super.openPopup();
    this.ga4EventsService.sendOffersElementEvent(Ga4OffersElementKey.ACCIDENTS_HAPPEN_BANNER);
  }

}
